import { queryOptions, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/api/utils/queryKeys';
import { Modal } from '@/components/ModalRenderer/Modal';
import { PortableTextContent } from '@/components/shared';
import { cmsApi } from '@/integrations/sanity/api';

const privacyPolicyQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.cms.privacyPolicy,
    queryFn: () => cmsApi.getPrivacyPolicy(),
    staleTime: Infinity,
  });

const PrivacyPolicy = () => {
  const { data: privacyPolicyData } = useQuery(privacyPolicyQueryOptions());

  if (!privacyPolicyData) {
    return null;
  }

  return (
    <Modal title={privacyPolicyData.heading ?? 'Integritetspolicy'}>
      <div className="flex flex-col gap-4">
        {privacyPolicyData.contentBlockGroup?.contentBlocks?.map(contentBlock => (
          <div key={contentBlock._key}>
            <div className="flex flex-col gap-4">
              <h3 className="text-section-util">{contentBlock.title}</h3>
              {!!contentBlock.body && <PortableTextContent value={contentBlock.body} />}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default PrivacyPolicy;
